import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import App from './components/App';
import store from './store';
import customMantineTheme from './mantineTheme';

import './index.css';

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <MantineProvider theme={customMantineTheme}>
        <App />
      </MantineProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
